import { Component, OnInit } from '@angular/core';
import { CarouselService } from '../../services/carousel.service';
import { MatIconModule } from '@angular/material/icon';

interface additionalInfo {
  title: string;
  description: string;
  icon: string;
}
@Component({
  selector: 'cgw-additional-section',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './additional-section.component.html',
  styleUrl: './additional-section.component.scss',
})
export class AdditionalSectionComponent implements OnInit {
  constructor(private carouselService: CarouselService) {}
  public additionals: additionalInfo[] = [
    {
      title: 'Hasta 12 cuotas',
      description: 'abonando con tarjetas de crédito',
      icon: 'credit_card',
    },
    {
      title: 'Envíos a todo el país',
      description: 'a través de OCA',
      icon: 'local_shipping',
    },
    {
      title: 'Garantía oficial',
      description: 'de hasta 36 meses en todos los productos',
      icon: 'shield',
    },
  ];
  public ngOnInit(): void {}
}
